export default "__VITE_ASSET__ICM00fKH__"